import EmptyStatesPreview from '../content/EmptyStatesPreview'
import { AccessControl } from '@eggplant/context'
import { HiOutlineSave } from 'react-icons/hi'
import { LinkButton } from '@eggplant/pattern-library'
import { LinkToImportRequirements } from '@eggplant/routing'
import { LinkToRequirementsDoc } from '../links'
import { Requirements } from '@eggplant/pattern-library/src/lib/components/Artwork/Artwork'

const description = `Import requirements from a file and link tests to your requirements. From this page you will be able to track test results corresponding to these requirements for audit purposes, ensuring comprehensive testing and accurate documentation.

After importing requirements, proceed to link them to the steps of your test cases.

💪 Let’s import requirements to begin!`

// TODO ETD-2870 EPIC to add in new page and link to the page after clicking import, will removed <> frame by then.
const renderButton = () =>
  <AccessControl isHiddenIfDenied>
    <LinkButton variant='primary'>
      <LinkToImportRequirements>
        <HiOutlineSave
          aria-hidden
          size='18px'
        />
        Import requirements
      </LinkToImportRequirements>
    </LinkButton>
  </AccessControl>

const RequirementsIntro = () =>
  <div className='grid h-full justify-center'>
    <div className='grid w-[36em]'>
      <EmptyStatesPreview
        action={renderButton()}
        description={description}
        icon={<Requirements />}
        renderLink={<LinkToRequirementsDoc />}
        title='Requirements'
      />
    </div>
  </div>

export default RequirementsIntro
